module.exports = __webpack_public_path__ + "static/media/lcg-shape-purple-up.0f6baa86.svg";